import { Box, Link, Stack } from '@mui/material';

type Props = {
  gym_address?: string;
  gym_phone_number?: string;
};

export default function Footer({ gym_address, gym_phone_number }: Props) {
  return (
    <Box>
      {gym_address && (
        <Stack direction="row" justifyContent="center">
          <Link href="#" style={{ textDecoration: 'none' }}>
            {gym_address} | <u>{gym_phone_number}</u>
          </Link>
        </Stack>
      )}
      <Stack direction="row" justifyContent="center" spacing={2}>
        <Link href={import.meta.env.VITE_GYMOWNERS_TERMS_OF_USE} target="_blank">
          Terms of Use
        </Link>
        <Link href={import.meta.env.VITE_GYMOWNERS_PRIVACY_POLICY} target="_blank">
          Privacy Policy
        </Link>
      </Stack>
    </Box>
  );
}
